module.exports = __webpack_public_path__ + "img/welcome-sell.e0109b88.svg";